import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";

import { ICategories } from "../models/categoriesresponse.model";
import { CoreService } from "../../shared/services/core.service";
import {
  ESubCategoriesActions,
  GetSubCategories,
  GetSubCategoriesSuccess,
} from "../actions/sub-category.actions";
import { CategoryService } from "src/app/shared/services/category.service";
import { ISubCategories } from "../models/sub-categoriesresponse.model";

@Injectable()
export class SubCategoriesEffects {
  getSubCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetSubCategories>(ESubCategoriesActions.GetSubCategories),
      switchMap((action) =>
        this.categoryService.getCategories(action.payload).pipe(
          map(
            (subCategories: ISubCategories) =>
              new GetSubCategoriesSuccess(subCategories)
          ),
          catchError((error) => {
            console.error("Error fetching subcategories:", error);
            return of(); // Optionally dispatch an error action here
          })
        )
      )
    )
  );

  constructor(
    private categoryService: CategoryService,
    private actions$: Actions
  ) {}
}
